import { config } from "./config";
export type CheckoutOfferId = "lifetime" | "polar_trial_7d";
export type CheckoutProvider = "stripe" | "polar";

export type CheckoutOffer = {
  id: CheckoutOfferId;
  provider: CheckoutProvider;
  analyticsKey: string;
  trialDays: number;
  renewalCopy: string;
};

const TRIAL_OFFER_QUERY_VALUES = new Set([
  "trial-yearly",
  "trial_yearly",
  "trial-7d",
  "trial_7d",
  "free-trial",
  "free_trial",
  "polar-trial",
  "polar_trial",
  "polar_trial_7d",
]);

const parsePositiveInteger = (value: string, fallback: number): number => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const defaultCheckoutOffer: CheckoutOffer = {
  id: "lifetime",
  provider: "polar",
  analyticsKey: "lifetime",
  trialDays: 0,
  renewalCopy: "",
};

export const getCheckoutOfferFromLocation = (location: Location): CheckoutOffer => {
  const params = new URLSearchParams(location.search);
  const rawOffer = params.get("offer") ?? params.get("checkout_offer") ?? "";
  const normalizedOffer = rawOffer.trim().toLowerCase();

  if (!TRIAL_OFFER_QUERY_VALUES.has(normalizedOffer)) {
    return defaultCheckoutOffer;
  }

  return {
    id: "polar_trial_7d",
    provider: "polar",
    analyticsKey: "polar_trial_7d",
    trialDays: parsePositiveInteger(config.polarTrialDays, 7),
    renewalCopy: config.polarTrialRenewalCopy,
  };
};

export const isPolarTrialOffer = (offer: CheckoutOffer): boolean => offer.id === "polar_trial_7d";
